"use client"

import { useOrchestrator } from "@/contexts/OrchestratorContext"
import { SpinnerGapIcon as Loader2 } from "@phosphor-icons/react/dist/csr/SpinnerGap"
import { CheckCircleIcon as CheckCircle2 } from "@phosphor-icons/react/dist/csr/CheckCircle"
import { XCircleIcon as XCircle } from "@phosphor-icons/react/dist/csr/XCircle"
import { LightningIcon as Zap } from "@phosphor-icons/react/dist/csr/Lightning"
import { WorkflowDialog } from "./WorkflowDialog"

export function WorkflowBanner() {
  const { workflows, dialogOpen, setDialogOpen } = useOrchestrator()

  if (workflows.size === 0) return null

  const all = Array.from(workflows.values())
  const running = all.filter((w) => w.status === "running").length
  const completed = all.filter((w) => w.status === "completed").length
  const failed = all.filter((w) => w.status === "failed").length

  const hasRunning = running > 0
  const hasFailed = failed > 0

  const bgClass = hasRunning
    ? "bg-primary hover:bg-primary/90"
    : hasFailed
    ? "bg-red-600 hover:bg-red-700"
    : "bg-emerald-600 hover:bg-emerald-700"

  return (
    <>
      <button
        onClick={() => setDialogOpen(true)}
        className={`fixed bottom-4 right-4 z-50 flex items-center gap-2.5 px-4 py-2.5 rounded-full text-white text-sm font-medium shadow-lg transition-all cursor-pointer ${bgClass} ${hasRunning ? "animate-pulse" : ""}`}
      >
        {hasRunning ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : hasFailed ? (
          <XCircle className="h-4 w-4" />
        ) : (
          <CheckCircle2 className="h-4 w-4" />
        )}

        <span className="flex items-center gap-1.5">
          <Zap className="h-3.5 w-3.5" />
          {running > 0 && <span>{running} running</span>}
          {completed > 0 && <span>{running > 0 ? " · " : ""}{completed} done</span>}
          {failed > 0 && <span>{(running > 0 || completed > 0) ? " · " : ""}{failed} failed</span>}
        </span>

        <span className="flex items-center justify-center h-5 w-5 rounded-full bg-card/20 text-xs font-bold">
          {all.length}
        </span>
      </button>

      <WorkflowDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </>
  )
}
